import styled from '@emotion/styled';
import {
    BaseButton,
    Variables,
    LayoutRow,
    DataTable,
} from '@enter/core';

export const Loader = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 1 40%;
    justify-content: center;

    & > svg {
        background-color: transparent;
    }
`;

export const HeaderRow = styled(LayoutRow)`
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
`;

export const PageTitle = styled.h1`
    margin: 0;
    line-height: 1;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.p500};
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 12px;
`;

export const ActionButton = styled(BaseButton)`
    min-width: 120px;
`;

export const BalanceCard = styled.div`
    margin-bottom: 24px;
`;

export const BalanceContent = styled.div`
    padding: 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const BalanceAmount = styled.div`
    color: ${Variables.Colors.p500};
    font-size: 18px;
    font-weight: 600;
`;

export const PayButton = styled(BaseButton)`
    min-width: 120px;
`;

export const CardsRow = styled(LayoutRow)`
    flex-direction: row;
    gap: 24px;
    margin-bottom: 32px;
    align-items: stretch;
`;

export const HalfWidthCard = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    
    & > * {
        flex: 1;
        display: flex;
        flex-direction: column;
    }
`;

export const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px;
`;

export const PatientName = styled.div`
    color: ${Variables.Colors.p500};
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ProviderName = styled.div`
    color: ${Variables.Colors.p500};
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
`;

export const SexBadge = styled.span`
    display: inline-flex;
`;

export const InfoRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;

export const InfoLabel = styled.div`
    color: ${Variables.Colors.n70};
    min-width: 100px;
`;

export const InfoValue = styled.div`
    color: ${Variables.Colors.n100};
`;

export const EmailLink = styled.a`
    color: ${Variables.Colors.b300};
    text-decoration: none;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;

export const TableCardWrapper = styled.div`
    margin-bottom: 24px;

    .summary-row {
        font-weight: 600;
        border-top: 1px solid ${Variables.Colors.n30};
        background-color: ${Variables.Colors.n15_24};
        
        &:hover {
            background-color: ${Variables.Colors.n15_24} !important;
        }
    }

    .pending-row {
        background-color: #F1F3F5;
        
        &:hover {
            background-color: #E8EAED !important;
        }
    }
`;

export const TableCardTitle = styled.div`
    color: ${Variables.Colors.p500};
    font-size: 16px;
    font-weight: 600;
    padding: 20px 0;
`;

export const TableHeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
`;

export const FilterRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
`;

export const FilterLabel = styled.span`
    color: ${Variables.Colors.n70};
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    margin-right: 4px;
`;

export const FilterSeparator = styled.span`
    color: ${Variables.Colors.n70};
    font-size: 16px;
    padding: 0 4px;
`;

export const ClearFilterButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    color: ${Variables.Colors.n70};
    line-height: 0;

    &:hover {
        color: ${Variables.Colors.n100};
        background-color: ${Variables.Colors.n15};
    }
`;

export const ClaimsTable = styled(DataTable)`
    [role='cell'] {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0;
        
        > * {
            padding: 8px 16px;
        }
    }

    [role='columnheader'] {
        white-space: normal;
        word-wrap: break-word;
        overflow-wrap: break-word;
        padding: 8px 16px;
        cursor: default !important;
        user-select: none;
        
        &:hover {
            background-color: transparent !important;
            color: inherit !important;
        }

        .sort-indicator,
        .sort-indicator-container {
            pointer-events: none;
        }

        .resizer {
            pointer-events: auto;
        }
    }
`;

